
import { Component, Prop, Vue } from "vue-property-decorator";
import { commonModule, offersModule } from "@/store/modules/store-accessor";

@Component
export default class EditOfferPhotoModal extends Vue {
  @Prop() payload!: { photo: OfferPhotoDto; offer: OfferDto };

  notes = this.payload.photo.notes || "";
  isUpdating = false;

  notesRules = [
    (val: string) => !val || val.length <= 50 || this.$t("photoNotesRule"),
  ];

  get photoUrl() {
    return `${this.payload.photo.base_url.replace(
      /\/$/,
      ""
    )}/${this.payload.photo.src.replace(/^\//, "")}`;
  }

  hideModal() {
    commonModule.hideModal();
  }

  async updatePhoto() {
    const form = this.$refs.form as Vue & { validate: () => boolean };
    if (!form.validate()) return;

    this.isUpdating = true;
    try {
      await offersModule.updateOfferPhoto({
        installationId: String(this.payload.offer.installation_id),
        offerId: String(this.payload.offer.id),
        photoId: String(this.payload.photo.id),
        notes: this.notes,
      });
      this.hideModal();
    } finally {
      this.isUpdating = false;
    }
  }
}
